import { Story } from '../../types/story';

export const londonFootball2: Story = {
  id: 'london-football-2',
  title: 'The Locker Room - Part 2',
  excerpt: 'After the shower encounter that changed everything, James finds himself caught between his unhappy marriage and the intense connection forming with his two teammates. The locker room becomes their sanctuary, but secrets have a way of getting out.',
  city: 'London',
  publishDate: '2026-01-25',
  readTime: '40 min read',
  tags: ['♂♂♂', 'football', 'locker-room', 'bicurious', 'complicated'],
  categories: ['intense', 'queer'],
  intensity: 3,
  content: `I went home that night smelling like Liam's soap and Marco's approval. Sarah was already in bed, reading some novel she'd been obsessed with for weeks.

"You're late," she said, not looking up from her book. "And you smell like a locker room."

"Long shower after the match," I said, which wasn't technically a lie. "Lost again."

"You always lose," she said, finally looking at me. "Maybe you should find a different hobby."

"Maybe I should," I agreed, but I was thinking about a different kind of hobby entirely.

I climbed into bed, but sleep wouldn't come. All I could think about was the shower—Liam's hands on my body, his mouth on mine, the way he'd felt in my hand, the taste of him. All I could think about was Marco watching, his knowing eyes, his quiet approval.

All I could think about was that I wanted more.

The next week was torture. Every training session, every moment in the locker room, was charged with unspoken meaning. Liam and I would exchange glances, small smiles that said everything and nothing at all. Marco would watch us both, his expression thoughtful, calculating.

But we didn't touch again. Not yet.

"Are you okay?" Liam asked after practice on Thursday, while the other guys were still in the showers. "You seem... distracted."

"I'm fine," I lied. "Just work stuff."

"It's Sarah, isn't it?" Marco said, appearing behind us. "You're thinking about what happened and feeling guilty."

"I'm not feeling guilty," I said, but I was. I was feeling guilty about wanting more, about not feeling guilty enough.

"You should feel guilty," Liam said gently. "But not about what we did. About staying in a marriage that makes you miserable."

"That's not fair," I protested. "Sarah's not a bad person. She's just... not right for me anymore."

"Then leave," Marco said simply. "What's stopping you?"

Everything was stopping me. The mortgage, the shared friends, the history, the fear of being alone, the fear of what I was becoming.

"It's complicated," I said weakly.

"Life is complicated," Liam agreed. "But happiness doesn't have to be."

Saturday's match was different. We won—actually won, 2-1—and the mood in the locker room was celebratory. The other guys were loud, boisterous, slapping each other on the back, planning to go to the pub.

But the three of us lingered, like always.

"We should celebrate," Liam said, his eyes on me. "Privately."

"My place," Marco suggested. "Sarah's visiting her sister this weekend, right?"

I nodded. Sarah was indeed visiting her sister in Brighton, wouldn't be back until Sunday evening. The thought made me feel equal parts relieved and guilty.

"Good," Marco said. "Come over around eight. Bring beer."

I spent the afternoon in a state of nervous anticipation. I cleaned the apartment obsessively, changed clothes three times, tried to read but couldn't focus. At seven, I texted Sarah: "Having a great time! Miss you!" The lie felt heavy in my stomach.

Marco's flat was exactly what I expected—minimalist, expensive, with architectural drawings on the walls and a view of London that made my place look like a closet.

Liam was already there, leaning against the kitchen counter, drinking wine. He'd changed out of his football gear into dark jeans and a fitted shirt that showed off his lean frame.

"James," he said, and his voice was different here, softer, more intimate.

"Hi," I managed, my hands shaking slightly.

"Relax," Marco said, taking my coat. "We're just friends hanging out. Nothing more."

But we all knew that was a lie.

We drank beer on Marco's balcony, watching the city lights come on. The conversation was easy at first—football, work, the usual stuff. But underneath it all was this tension, this anticipation, this knowledge that we were here for something else.

"Can I ask you something?" Liam said, setting down his beer. "What do you want, James? Really want?"

I looked at him, then at Marco. "I don't know."

"Yes, you do," Marco said gently. "You're just scared to say it out loud."

"I want..." I started, then stopped. "I want what happened in the shower. But I want more. I want... everything."

"Everything," Liam repeated. "What does that mean?"

"It means I want both of you," I said, the words tumbling out before I could stop them. "Not just once. Not just experimenting. I want... this. Whatever this is."

Marco and Liam exchanged a look, some silent communication passing between them.

"Are you sure about that?" Liam asked. "Because that changes things. That makes this... real."

"I'm sure," I said, and I was. "I've never been more sure of anything."

"Good," Marco said. "Because we want the same thing."

That's when everything changed.

Marco moved first, coming to stand in front of me, his hands on my face. "You're so beautiful when you're being honest," he murmured, before kissing me.

His kiss was different from Liam's—harder, more demanding, more possessive. Like he'd been waiting for this moment, waiting for permission to take what he wanted.

Liam joined us, his hands on my waist, his mouth on my neck. I was caught between them, surrounded by them, and I felt something I'd never felt before—completely wanted, completely desired, completely safe.

"Let's go to the bedroom," Marco said, pulling away slightly.

His bedroom was large, dominated by a king-sized bed with dark sheets. The lights were dim, the city visible through the huge windows.

"Undress for us," Liam commanded, and I did, my hands shaking as I pulled off my shirt, my jeans, my underwear.

When I was naked, they both looked at me, their eyes dark with desire.

"Perfect," Liam breathed. "Absolutely perfect."

They undressed too, and I saw them both properly for the first time. Liam was lean and graceful, like a dancer. Marco was more muscular, broader, with a scattering of dark hair across his chest. Both were beautiful, both were hard, both were looking at me like I was something to be devoured.

"On the bed," Marco said, and I obeyed, lying back on the dark sheets.

They joined me, Liam on one side, Marco on the other. For a moment, we just lay there, touching, exploring, learning each other's bodies.

"I want to taste you," Liam murmured, kissing his way down my chest, my stomach.

"I want to be inside you," Marco said, his hand on my thigh, his fingers teasing my entrance.

"Yes," I breathed. "God, yes."

Liam took me in his mouth while Marco prepared me, his fingers stretching me, scissoring me, getting me ready. The sensation was overwhelming—two sets of hands, two mouths, two different approaches to pleasure.

When Liam moved away, Marco positioned himself between my legs. "Are you ready?" he asked.

"Yes," I said, though I wasn't sure I was. "Please."

He entered me slowly, carefully, and I gasped at the sensation—full, stretched, possessed. He was bigger than I'd expected, thicker, and it burned slightly before it turned to pleasure.

"Move," I begged. "Please move."

He started slow, letting me adjust, then faster, harder. Liam was watching us, stroking himself, his eyes dark with desire.

"Come here," I said to Liam, and he moved closer, positioning himself over my face.

I took him in my mouth while Marco fucked me, and I was completely lost in sensation—Marco filling me from behind, Liam filling my mouth, the sounds of their pleasure mixing with mine.

"You look so good like this," Liam breathed, his hips moving, fucking my mouth. "So perfect between us."

I could feel Marco getting close, his movements becoming erratic, his breathing harsher. "I'm going to come," he warned.

"Come inside me," I begged. "Please."

He did, with a groan, his release filling me, and the sensation pushed me over the edge. I came hard, my body arching, my cries muffled by Liam's cock.

Liam followed soon after, pulling out at the last second, his release spilling onto my chest.

We lay tangled together afterward, our bodies slick with sweat, our breathing slowly returning to normal.

"Wow," I said finally. "Just... wow."

"Welcome to everything," Marco said, his hand on my chest. "This is what you wanted, right?"

"It's better than I imagined," I admitted.

"We're not done yet," Liam said, and I could feel him getting hard again against my thigh. "The night's still young."

And it was. We explored every combination, every possibility. Marco and Liam together while I watched, then all three of us together. I took both of them, one after the other, then at the same time. We pushed boundaries, tried new things, lost ourselves in pleasure.

By the time the sun started to rise, we were exhausted but satisfied. We lay tangled together in Marco's bed, watching the London sky lighten.

"What happens now?" I asked, my head on Marco's chest, Liam's hand in mine.

"Now we figure it out," Marco said. "Together."

"What about Sarah?" Liam asked gently.

"I have to tell her," I said. "I can't keep lying to her. I can't keep living a lie."

"Are you sure you're ready for that?" Marco asked.

"No," I admitted. "But I'm ready to start being honest. With her, with myself, with you."

"Good," Liam said. "Because we're not letting you go. Not now."

"Not ever," Marco agreed.

I fell asleep between them, feeling safer and more wanted than I'd ever felt in my life. For the first time in years, I wasn't thinking about what I should do, what was expected of me, what made sense.

I was just thinking about what I wanted.

And what I wanted was this.

All of this.

Forever.

But forever is a long time, and the morning would bring complications I wasn't ready for. Sarah would be home tomorrow. My life would come crashing back in. The bubble we'd created would have to burst.

But for tonight, in Marco's bed, between the two men who were changing everything, I was happy.

And that was enough.

For now.`
};
